import React from 'react';

const AlumniSteps = () => {
  return (
    <div>
      <h2 className="mb-1">Almost There!</h2>
      <p className="font-18">Just 2 more steps to unlock Lifetime benefits!</p>
      <hr className="opacity-25" />
    </div>
  );
};

export default AlumniSteps;
